import React from 'react'
import './Connexion.css'
import Logo from '../../Assets/logo_ornoir_market.svg'

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../firebase/firebase'
import Notif from '../../components/Notif/Notif'

const Connexion = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [Message,setMessage]=useState()

  const Connecter = (e) => {
      e.preventDefault();
      signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
          // Signed in
          //const user = userCredential.user;

          //setMessage("vous êtes connecté")
          //setnotif(true)

          navigate("/dashboard")
          //console.log(user);
          //alert(user)
          
      })
      .catch((error) => {
          const errorCode = error.code;
          //const errorMessage = error.message;
          //console.log(errorCode, errorMessage)
          //alert(errorCode, errorMessage)
          document.querySelector('#ErrorDial').showModal()
         
          switch (errorCode) {
            case "auth/invalid-email":
                setMessage('Veuillez Verifier le champ mail')
                break;

            case "auth/missing-password":
                setMessage('Veuillez Verifier le champ mot de passe')
                break;

            case "auth/invalid-credential":
                setMessage('Le compte n\'existe pas ')
                break;

            default:
                setMessage('Vérifiez le formulaire')
                break;
          }
          
      });

  }



  return (
    <main className='Connexionpage'>

        <Notif Message={Message}/>

        <div className='Connexionpagediv'>
            <div>
                <img src={Logo} alt="Logo Market" />
            </div>

            <div id='formulaire'>
                  
                    <input id='Username' name='email' required type="text"  placeholder='Nom d’utilisateur' onChange={(e)=>setEmail(e.target.value)}/>
                    
                    <input type="password" name="password" required id="password"  placeholder='mot de passe' onChange={(e)=>setPassword(e.target.value)}/>
                    
            </div>

            <div id="buttonconnexion" onClick={Connecter}>
                Connexion
            </div>

            
        </div> 
        
    </main>
  )
}

export default Connexion